import {
  useCouponListReady,
  useEffectiveAppliedCoupon,
} from 'src/features/Coupon/Regular/states'
import { useMyInfo } from 'src/services/apollo/auth'
import type { ExtraPackagePromotionOption } from '../api/types'

/**
 * Compute the promotion option (coupon code) to feed `useExtraPackages`.
 *
 * Anonymous users skip the coupon ready-check. Logged-in users wait for
 * the coupon list to be ready before issuing the price query — otherwise
 * the query would race and double-fetch.
 */
export function usePackPromotionOption(): {
  promotionOption: ExtraPackagePromotionOption | null
  shouldWaitForCoupons: boolean
} {
  const { data: userInfo } = useMyInfo()
  const couponListReady = useCouponListReady()
  const effectiveCouponCode = useEffectiveAppliedCoupon()

  const shouldWaitForCoupons = Boolean(userInfo) && !couponListReady

  return {
    promotionOption: shouldWaitForCoupons
      ? null
      : { extraPackageBoostCode: effectiveCouponCode ?? undefined },
    shouldWaitForCoupons,
  }
}
